module.exports = __webpack_public_path__ + "static/media/verhaltensbasiert_step_4_neg.d44a0217.png";